import { render, staticRenderFns } from "./ReadingFoodPage.vue?vue&type=template&id=992f351c&scoped=true&"
import script from "./ReadingFoodPage.vue?vue&type=script&lang=js&"
export * from "./ReadingFoodPage.vue?vue&type=script&lang=js&"
import style0 from "./ReadingFoodPage.vue?vue&type=style&index=0&id=992f351c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992f351c",
  null
  
)

export default component.exports